import type { ProductDetailTableRowProps } from './data';

import { Box, Stack, Text } from '@/components';

const ProductDetailsTableRow: ProductDetailTableRowProps = ({
  title,
  value,
}) => {
  return (
    <Stack
      direction="row"
      mx={{ base: 2, md: '22px' }}
      _notLast={{ borderBottom: '1px solid', borderColor: 'gray.400' }}
    >
      <Stack
        borderLeftWidth={{ base: 0, md: '1px' }}
        borderColor="gray.400"
        pr={{ base: '9px', md: '49px' }}
        pl={{ base: '32px', md: '41px' }}
        py="18px"
        flex="1"
      >
        <Text
          fontSize={{ base: '11px', md: 'lg' }}
          color={{ base: 'gray.700', md: 'black' }}
        >
          {title}
        </Text>
      </Stack>
      <Box
        flex="4"
        w="full"
        py="18px"
        textAlign={{ base: 'right', md: 'center' }}
      >
        <Text
          fontSize={{ base: '11px', md: 'lg' }}
          color={{ base: 'gray.700', md: 'black' }}
        >
          {value}
        </Text>
      </Box>
    </Stack>
  );
};
export default ProductDetailsTableRow;
